import TemplatePagesRoutes from './routes'

const TemplatePages = () => (
  <TemplatePagesRoutes />
)

export default TemplatePages
